import React, { useState } from "react";
import { useGetSchoolBranches } from "../../../hooks/branchHooks/branch.hooks";
import { ListTable } from "../../Table/listTable/listTable";
import { branchListTitles } from "../../../Constants/tableTitles/ListTableTitle/branchList.titles";
import { transformBranchListTableData } from "../../../Services/transformer/transformBranchListTableData";
import { EditBranchModal } from "../EditBranch/EditBranchModal";
import { RemoveBranchModal } from "../RemoveBranchModal";
import { getValue } from "../../../utils/object.utils";

export const ListBranch = () => {
  const [branchDetail, setBranchDetail] = useState<object | null>(null);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [openCloseModal, setOpenCloseModal] = useState<boolean>(false);

  const { isLoading: isBrancheListLoading, data } = useGetSchoolBranches();

  const handleActionClick = (data: any) => {
    setBranchDetail(data);
  };

  return (
    <>
      <ListTable
        titles={branchListTitles}
        data={data}
        isDataLoading={isBrancheListLoading}
        transformFn={transformBranchListTableData}
        moreOptons={{
          onEdit: (data: any) => {
            if (!data) return null;
            handleActionClick(data);
            setOpenEditModal(true);
          },
          onRemove: (data: any) => {
            const branchId = getValue(data, "id");

            if (!branchId) return;
            handleActionClick(data);
            setOpenCloseModal(true);
          },
        }}
      />

      <EditBranchModal
        branchDetail={branchDetail}
        onClose={() => {
          setOpenEditModal(false);
        }}
        open={openEditModal}
      />

      <RemoveBranchModal
        branchDetail={branchDetail}
        open={openCloseModal}
        onClose={() => {
          setOpenCloseModal(false);
        }}
      />
    </>
  );
};
